<template>
  <header class="bg-nu2 header-section">
    <!-- nav ber section start -->
    <div class="sticky top-0 header sm:h-80 sm:pt-2 pt-2 bg-green-950/60">
      <div class="container">
        <nav class="flex justify-between items-center">
          <NuxtLink to="/" class="flex items-center">
            <img class="sm:w-[45px] w-[45px] sm:h-[45px] h-[45px]" src="/logo.png" alt="" />
            <span class="pl-2 xl:text-[28px] lg:text-[24px] md:text-[20px] text-[20px] text-nu1 font-medium">TARA
              Play</span>
          </NuxtLink>
          <ul class="hidden lg:flex lg:items-center gap-6 mr-24">
            <li class="nav-item">
              <NuxtLink to="/" class="font-medium text-nu1">Home</NuxtLink>
            </li>

            <li class="nav-item">
              <NuxtLink to="/game" class="font-medium text-nu1">Our Games</NuxtLink>
            </li>
            <li class="nav-item">
              <NuxtLink to="/about" class="font-medium text-nu1">About</NuxtLink>
            </li>
          </ul>

          <div id="hamburger-menu" class="block md:hidden" @click="toggleMobileMenu">
            <span><PhList color="white" size="24" weight="bold" /></span>
          </div>
        </nav>
        <!-- navber mobile version -->
        <div id="mobile-menu" class="lg:hidden block" :class="showMenu ? 'show-menu' : ''" @click="toggleMobileMenu">
          <div class="mobile-nav-items">
            <ul class="text-center sidenav">
              <li class="">
                <NuxtLink to="/"
                  class="active font-medium text-nu1 md:text-[28px] sm:text-[24px] text-[20px]">Home</NuxtLink>
              </li>

              <li class="mt-10">
                <NuxtLink to="/game" class="font-medium text-nu1 md:text-[28px] sm:text-[24px] text-[20px]">Our
                  Games</NuxtLink>
              </li>
              <li class="mt-10">
                <NuxtLink to="/about"
                  class="font-medium text-nu1 md:text-[28px] sm:text-[24px] text-[20px]">About</NuxtLink>
              </li>
            </ul>
          </div>

          <div id="hamburger-cross">
            <span><PhX color="white" size="24" weight="bold" /></span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
  import { PhX, PhList } from "@phosphor-icons/vue";
  const showMenu = ref(false);
  const toggleMobileMenu = () => {
    showMenu.value = !showMenu.value;
  };
</script>